import * as React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "@reach/router";
import { FaArrowRight } from "react-icons/fa";

const StyledContainer = styled(Container)`
  .btn:hover > a {
    color: #fff !important;
  }

  button {
    margin: 0 28px !important;
  }
`;

const QuickEmailVerify = () => {
  return (
    <StyledContainer>
      <div className="row pt-4">
        <div className="col-sm-6 ">
          <h2>Email Validation</h2>
          <i>Verify any email addresses with utmost accuracy!</i>
          <ul className="text-left ">
            <li className="py-3 fa fa-circle">
              Clearout's versatile email verifier tool offers both real-time
              and bulk validation options to suit your needs
            </li>
            <li className="fa fa-circle">
              With the bulk email validation, you can upload CSV or XLSX files
              and receive detailed statistics on your email list's accuracy,
              including spam traps, bounces, and disposable emails
            </li>
            <li className="py-3 fa fa-circle">
              You can download the verified results and append them to your
              original file, making it easy to keep your database up-to-date
            </li>
            <li className="fa fa-circle">
              For smaller lists, our quick email verifier allows you to copy
              and paste email addresses & get instant results
            </li>
          </ul>
          <div className="align-center">
            <Link to="/email-verifier/" aria-label="Explore Email Verifier" className="btn btn-outline-dark px-3">
              Explore <FaArrowRight />
            </Link>
          </div>
        </div>
        <div className="col-sm-6 ">
          <StaticImage
            src="../../images/clearout_quick_validation_with_ai_verdict.png"
            className="mw-100"
            alt="Clearout's Email Verifier with highest accuracy"
          />
        </div>
      </div>
    </StyledContainer>
  );
};

export default QuickEmailVerify;
